import { render, staticRenderFns } from "./DispatchTactics.vue?vue&type=template&id=0f1d1856&scoped=true&"
import script from "./DispatchTactics.vue?vue&type=script&lang=js&"
export * from "./DispatchTactics.vue?vue&type=script&lang=js&"
import style0 from "./DispatchTactics.vue?vue&type=style&index=0&id=0f1d1856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d1856",
  null
  
)

export default component.exports